export const theme = {
  '2': {
    imgUrl: 'blue',
    hasLogo: false,
    theme: {
      dark: '#4EA6F0',
      light: '#dcedfc'
    }
  }
}
